import { render, staticRenderFns } from "./AddReplyTemplate.vue?vue&type=template&id=6f674975&"
import script from "./AddReplyTemplate.vue?vue&type=script&lang=js&"
export * from "./AddReplyTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports